import { Routes } from '@angular/router';
import { noAuthGuard } from './guards/no-auth.guard';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.routes').then(m => m.LOGIN_ROUTES),
    canActivate: [noAuthGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home/mantenedores',
    loadChildren: () => import('./layout-home/layout-home.routes').then(m => m.LAYOUT_HOME_ROUTES),
    canActivate: [authGuard],
  },
];
